// 一键申报
const taxManagement = () => import("@/components/platform/taxManagement/index");
const duesManage = () => import("@/components/dues/duesManage");
const middleNumber = () => import("@/components/dues/middleNumber");
// 专享号提货
const exclusiveNumPicking = () =>
  import("@/components/dues/exclusiveNumPicking/index");
// 办税专享号
const taxExclusiveNum = () => import("@/components/dues/taxExclusiveNum/index");
// 外呼业务
const agentManagement = () => import("@/components/callCenter/agentManagement");
const callRecord = () => import("@/components/callCenter/callRecord");
const callCount = () => import("@/components/callCenter/callCount");
const callAudit = () => import("@/components/callCenter/callAudit");
const discount = () => import("@/components/callCenter/discount");
const lineManage = () => import("@/components/callCenter/lineManage/index");
const addWhite = () => import("@/components/callCenter/addWhite/index");
const monitoring = () => import("@/components/callCenter/monitoring/index");
const consumeDetail = () => import("@/components/callCenter/consumeDetail");
const callRecordDetail = () =>
  import("@/components/callCenter/callRecordDetail");
const whiteList = () => import("@/components/callCenter/whiteList");
// 物流业务
const logistics = () => import("@/components/platform/jd-logistics/logistics");
const waybill = () => import("@/components/platform/jd-logistics/waybill");
const freight = () => import("@/components/platform/jd-logistics/freight");
const orderCount = () =>
  import("@/components/platform/jd-logistics/orderCount");
const expressage = () =>
  import("@/components/platform/jd-logistics/expressage/expressage");
const carton = () => import("@/components/platform/jd-logistics/carton");
// 猪哥财务宝
const priceSet = () => import("@/components/accounting/priceSet/index");
const order = () => import("@/components/accounting/order/index");
const accountNumber = () =>
  import("@/components/accounting/accountNumber/index");
// 电子合同
const contractCenter = () => import("@/components/contract/center/index");
const tenant = () => import("@/components/contract/tenant/index");
const changeLog = () => import("@/components/contract/changeLog/index");
const contractCenterList = () => import("@/components/contract/center/list");
const contractTask = () => import("@/components/contract/task/index");
const verifySeal = () => import("@/components/contract/newContract/verifySeal");
// 新的印章审核
const newSeal = () =>
  import("@/components/contract/newContract/verifySeal/newSeal");
// 签署存证
const depository = () =>
  import("@/components/contract/newContract/depository/index");

// 支付业务
const remittanceAccount = () =>
  import("@/components/platform/remittanceAccount/index");
const settlementDetails = () =>
  import("@/components/platform/remittanceAccount/settlementDetails");
const payApply = () => import("@/components/company/iPayment/payApply"); //汇付申请管理
const seeDetails = () => import("@/components/company/iPayment/seeDetails"); //审核-查看详情页面
// 短信业务/ 短信记录
const smsLogsPlat = () => import("@/components/platform/smsLogs/index");
// 知识付费/   文书管理

// 企微管理
const enterpriseOpen = () =>
  import("@/components/enterpriseManage/enterpriseOpen"); //企微开通
const enterpriseOrder = () =>
  import("@/components/enterpriseManage/enterpriseOrder"); //企微开通

// 数智化系统
const priceManage = () => import("@/components/INCsystem/priceManage/index");
const orderManage = () => import("@/components/INCsystem/orderManage/index");
const firmManage = () => import("@/components/INCsystem/firmManage/index");
// 智能标签开通
const smartTagActivation = () =>
  import("@/components/smartTagActivation/index");
const labelManagement = () => import("@/components/labelManagement/index");
export default [
  {
    path: "/enterpriseOrder",
    name: "enterpriseOrder",
    meta: {
      text: "企微订单",
    },
    component: enterpriseOrder,
  },
  {
    path: "/labelManagement",
    name: "labelManagement",
    meta: {
      text: "客户标签",
    },
    component: labelManagement,
  },
  {
    path: "/enterpriseOpen",
    name: "enterpriseOpen",
    meta: {
      text: "企微开通",
    },
    component: enterpriseOpen,
  },
  {
    path: "/taxManagement",
    name: "taxManagement",
    component: taxManagement,
    meta: {
      text: "税号管理",
    },
  },
  {
    path: "/duesManage",
    name: "duesManage",
    meta: {
      text: "办税小号",
    },
    component: duesManage,
  },
  {
    path: "/middleNumber",
    name: "middleNumber",
    meta: {
      text: "中间号码池",
    },
    component: middleNumber,
  },
  {
    path: "/exclusiveNumPicking",
    name: "exclusiveNumPicking",
    meta: {
      text: "专享号提货",
    },
    component: exclusiveNumPicking,
  },
  {
    path: "/taxExclusiveNum",
    name: "taxExclusiveNum",
    meta: {
      text: "办税专享号",
    },
    component: taxExclusiveNum,
  },
  {
    path: "/agentManagement",
    name: "agentManagement",
    meta: {
      text: "坐席管理",
    },
    component: agentManagement,
  },
  // 呼叫记录 5.0.1需求
  {
    path: "/callRecord",
    name: "callRecord",
    meta: {
      noStore: true,
    },
    component: callRecord,
  },
  // 呼叫记录 5.0.1需求
  {
    path: "/callRecordDetail",
    name: "callRecordDetail",
    meta: {
      text: "通话明细",
    },
    component: callRecordDetail,
  },
  {
    path: "/callWhiteList",
    name: "callWhiteList",
    meta: {
      text: "白名单管理",
    },
    component: whiteList,
  },
  {
    path: "/callCount",
    name: "callCount",
    meta: {
      text: "呼叫统计",
    },
    component: callCount,
  },
  // 呼叫审核
  {
    path: "/callAudit",
    name: "callAudit",
    meta: {
      text: "呼叫审核",
    },
    component: callAudit,
  },
  {
    path: "/discount",
    name: "discount",
    meta: {
      text: "平台折扣",
    },
    component: discount,
  },
  {
    path: "/lineManage",
    name: "lineManage",
    meta: {
      text: "线路管理",
    },
    component: lineManage,
  },
  {
    path: "/addWhite",
    name: "addWhite",
    meta: {
      text: "加白管理",
    },
    component: addWhite,
  },
  // 外呼监控
  {
    path: "/monitoring",
    component: monitoring,
    children: [
      {
        meta: {
          text: "外呼监控",
        },
        path: "myMonitoring",
        name: "myMonitoring",
        component: (resolve) => {
          require([
            "@//components/callCenter/monitoring/myMonitoring.vue",
          ], resolve);
        },
      },
      {
        meta: {
          text: "外呼任务推送设置",
        },
        path: "pushSet",
        name: "pushSet",
        component: (resolve) => {
          require(["@//components/callCenter/monitoring/pushSet.vue"], resolve);
        },
      },
    ],
  },
  // 消费明细
  {
    path: "/consumeDetail",
    name: "consumeDetail",
    meta: {
      text: "消费明细",
    },
    component: consumeDetail,
  },
  {
    path: "/logistics",
    name: "logistics",
    meta: {
      text: "运单列表",
    },
    component: logistics,
  },
  // 5.2 需求 运单统计
  {
    path: "/orderCount",
    name: "orderCount",
    meta: {
      text: "运单统计",
    },
    component: orderCount,
  },
  {
    path: "/freight",
    name: "freight",
    meta: {
      text: "运费报价",
    },
    component: freight,
  },
  {
    path: "/expressage",
    name: "expressage",
    meta: {
      text: "快递公司",
    },
    component: expressage,
  },
  {
    path: "/waybill",
    name: "waybill",
    meta: {
      noStore: true,
    },
    component: waybill,
  },
  // 纸箱列表
  {
    path: "/carton",
    component: carton,
    children: [
      {
        meta: {
          text: "纸箱列表",
        },
        path: "cartonList",
        name: "cartonList",
        component: (resolve) => {
          require([
            "@//components/platform/jd-logistics/page/cartonList.vue",
          ], resolve);
        },
      },
      {
        meta: {
          text: "纸箱费设置",
        },
        path: "cartonFeeSet",
        name: "cartonFeeSet",
        component: (resolve) => {
          require([
            "@//components/platform/jd-logistics/page/cartonFeeSet.vue",
          ], resolve);
        },
      },
    ],
  },
  {
    path: "/priceSet",
    name: "priceSet",
    meta: {
      text: "价格设置",
    },
    component: priceSet,
  },
  {
    path: "/order",
    name: "order",
    meta: {
      text: "订单管理",
    },
    component: order,
  },
  {
    path: "/accountNumber",
    name: "accountNumber",
    meta: {
      text: "账号管理",
    },
    component: accountNumber,
  },
  {
    path: "/contractCenter",
    component: contractCenter,
    children: [
      {
        path: "index",
        name: "contractCenterIndex",
        meta: {
          text: "合同中心",
        },
        component: contractCenterList,
      },
    ],
  },
  {
    path: "/contractTask",
    name: "contractTask",
    meta: {
      text: "合同队列任务",
    },
    component: contractTask,
  },
  {
    path: "/tenant",
    name: "tenant",
    meta: {
      text: "已认证租户",
    },
    component: tenant,
  },
  {
    path: "/changeLog",
    name: "changeLog",
    meta: {
      text: "变更日志",
    },
    component: changeLog,
  },
  {
    path: "verifySeal",
    name: "verifySeal",
    meta: {
      text: "印章审核",
    },
    component: verifySeal,
  },
  {
    path: "verifySeal/newSeal",
    name: "newSeal",
    meta: {
      text: "印章审核",
    },
    component: newSeal,
  },
  {
    path: "/depository",
    name: "depository",
    meta: {
      text: "签署存证",
    },
    component: depository,
  },
  {
    path: "/remittanceAccount",
    name: "remittanceAccount",
    meta: {
      text: "汇付账户",
    },
    component: remittanceAccount,
  },
  {
    path: "/settlementDetails",
    name: "settlementDetails",
    meta: {
      text: "结算明细",
    },
    component: settlementDetails,
  },
  {
    path: "/payApply",
    name: "payApply",
    meta: {
      text: "汇付申请管理",
    },
    component: payApply,
  },
  {
    path: "/seeDetails",
    name: "seeDetails",
    meta: {
      text: "商户支付查看详情页面",
    },
    component: seeDetails,
  },
  {
    path: "/smsLogsPlat",
    name: "smsLogsPlat",
    meta: {
      text: "短信记录",
    },
    component: smsLogsPlat,
  },
  {
    meta: {
      text: "新增文书",
    },
    path: "lawFile/create",
    name: "lawCreate",
    component: (resolve) => {
      require(["@//components/contract/lawFile/list/create.vue"], resolve);
    },
  },
  {
    path: "lawFile",
    component: (resolve) => {
      require(["@//components/contract/lawFile/index.vue"], resolve);
    },
    children: [
      {
        meta: {
          text: "法律文书",
        },
        path: "index",
        name: "lawIndex",
        component: (resolve) => {
          require(["@//components/contract/lawFile/list/index.vue"], resolve);
        },
      },
      {
        meta: {
          text: "文书分类",
        },
        path: "kind",
        name: "lawKind",
        component: (resolve) => {
          require(["@//components/contract/lawFile/kind/index.vue"], resolve);
        },
      },
      {
        meta: {
          text: "文书订单",
        },
        path: "order",
        name: "lawOrder",
        component: (resolve) => {
          require(["@//components/contract/lawFile/order/index.vue"], resolve);
        },
      },
    ],
  },
  {
    path: "/szhPriceManage",
    name: "priceManage",
    meta: {
      text: "价格管理",
    },
    component: priceManage,
  },
  {
    path: "/szhOrderManage",
    name: "orderManage",
    meta: {
      text: "订单管理",
    },
    component: orderManage,
  },
  {
    path: "/szhFirmManage",
    name: "firmManage",
    meta: {
      text: "企业管理",
    },
    component: firmManage,
  },
  {
    path: "/smartTagActivation",
    name: "smartTagActivation",
    meta: {
      text: "标签智能开通",
    },
    component: smartTagActivation,
  },
];
